export default __webpack_public_path__ + "static/media/close.8f34b48c.svg";